import BaseLayout from '@/components/BaseLayout.vue';
import Promotion from './Promotion/Promotion.vue';
import api from "@/services/api";
import {mapGetters} from "vuex";

export default {
    name: 'newPromotion',

    data() {
        return {
            promotions: [],
        };
    },

    components: {
        BaseLayout,
        Promotion,
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        /**
         * Get all promotions from server
         */
        getPromotions() {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();

            today = `${yyyy}-${mm}-${dd}`;
            const params = new URLSearchParams();
            params.append('promoter', this.user.pcmsId);
            params.append('start_date', today);
            params.append('end_date', today);
            params.append('status', 1);
            api.post('/api/promotions_search', params)
                .then((response) => {
                    this.promotions = response.data.body.entries;
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getPromotions();
        }
    },

    mounted() {
        this.getPromotions();
    }
}